import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Media } from "react-bootstrap";
// import DataTable from "react-data-table-component";
// import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from '../Global';

const CustomerLogout = () => {
 // const [menu, setMenu] = useState(false);
//  const [data, setData] = useState([]);
 // const [backendSuccess, setBackendSuccess] = useState(null);
 // const [backendErrors, setBackendErrors] = useState(null);
  
    useEffect(() => {

      axios.post("/customerportal/logout", {},{
        headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if(response.data.code === 200){

          localStorage.removeItem("auth_email");
          localStorage.removeItem("auth_id");
          localStorage.removeItem("auth_token");
          localStorage.removeItem("fname");
          localStorage.removeItem("isLoggedIn");
          localStorage.removeItem("lname");
          localStorage.removeItem("menu_modules");
          localStorage.removeItem("role_id");
          localStorage.removeItem("user_type");
          localStorage.clear();
          window.location.href = "/customerportal/login";
        }else{
         alert('Something went wrong kindly refresh the page');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  
    }, []);

 
  // const toggleMobileMenu = () => {
  //   setMenu(!menu);
  // };
 

  return (
    <div className={`main-wrapper `}>
      

      <div className="page-wrapper">
       
      </div>
    </div>
  );
};
export default CustomerLogout;
